/* eslint-disable object-shorthand */
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import Chart from 'react-apexcharts'
import moment from 'moment'
import 'moment/locale/th'
import { Button, Stack } from '@chakra-ui/react'
import FetchingGraphData from '../Functions/FetchingGraphData'
import { useDispatch } from 'react-redux'
import * as actions from '../../../redux/actions'
import FilterCalendarDate from '../Functions/FilterCalendarDate'
import { useTranslation } from 'react-i18next'

export default function MultiGraph({
  data,
  stationData,
  chartData,
  valueFormat,
  tickAmount,
  graphMax,
  graphMin,
}) {
  const { t } = useTranslation()
  let sensorData = []
  let userGauge = _.filter(stationData.sensors, (sensor, index) =>
    _.map(chartData, (item) => {
      if (item.chartSensorRef === sensor.refString) {
        sensorData.push(sensor)
      }
    })
  )
  const [valueStackRealTime, ValueStackRealTime] = useState(
    _.map(sensorData, (eachSensor) =>
      FetchingGraphData(data?.arr, eachSensor._id)
    )
  )

  //Default Options
  const options = {
    xaxis: {
      type: 'datetime',
      labels: {
        formatter: (value) => {
          return moment(value).format(valueFormat)
        },
      },
      tickAmount: tickAmount,
      min: graphMin,
      max: graphMax,
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          return parseFloat(value).toFixed(2)
        },
      },
      min: (min) => min,
      max: (max) => max + 1,
      tickAmount: 5,
      // title: {
      //   text:
      //     chartData?.valueLabel +
      //     (chartData?.labelOnSituation?.enable === true ? '' : ' (') +
      //     chartData?.valueUnit +
      //     (chartData?.labelOnSituation?.enable === true ? '' : ') '),
      // },
    },
    tooltip: {
      x: {
        show: true,
        formatter: (value) => moment(value).format('D MMM - HH:mm'),
      },
      y: {
        formatter: (value) => {
          return parseFloat(value).toFixed(2) + ' ' + chartData[0].valueUnit
        },
        title: {
          formatter: (seriesName) => {
            return seriesName.name
          },
        },
        style: {
          fontWeight: '400',
        },
      },
    },
    // stroke: {
    //   curve: chartData.chartCurve,
    // },
    dataLabels: {
      formatter: (value, opts) => {
        return parseFloat(value).toFixed(2)
      },
      enabled: false,
      background: {
        enabled: true,
        foreColor: '#fff',
      },
      textAnchor: 'small',
    },
    chart: {
      toolbar: {
        tools: {
          zoomin: false,
          zoomout: false,
        },
        export: {
          csv: {
            headerCategory: 'Date',
            headerValue: chartData.valueLabel,
            categoryFormatter: (timestamp) =>
              moment(timestamp).format('DD/MM/YYYY HH:mm'),
          },
        },
      },
    },
  }

  // const series = []
  const series = [
    {
      name: 'Real-Time',
      data: _.reverse(valueStackRealTime[0]),
    },
    {
      name: 'Prediction',
      data: _.reverse(valueStackRealTime[1]),
    },
  ]

  const seriesA = _.map(chartData, (eachChart, index) => {
    return {
      name: eachChart.chartLabel,
      data: _.reverse(valueStackRealTime[index]),
    }
  })

  return (
    <div>
      {/* <h4 className="font-bold text-xl font-sans ">{chartData?.chartLabel}</h4> */}

      <Chart
        type="line"
        series={seriesA}
        options={options}
        width="100%"
        height="400px"
      />

      <br />
    </div>
  )
}
